import * as React from "react";
import { css } from "@emotion/core";
// @ts-ignore
import check from "../../../img/check@2x.png";

export const Check = (props: { checked: boolean }) => (
  <div
    css={css`
      position: absolute;
      right: -20px;
      top: -20px;
      width: 40px;
      height: 40px;
      border-radius: 20px;
      box-shadow: 0 2px 2px rgba(0, 0, 0, 0.25);
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
    `}
  >
    <img
      src={check}
      width={22}
      css={css`
        ${props.checked ? "" : "opacity: 0.1;"}
      `}
    />
  </div>
);
